Realize.i18n.registerLocale({
	actions: {
		add: 'Agregar datos a la tabla',
		mobileAdd: 'Agregar',
		update: "Actualización",
		close: 'Cerrar',
		back: 'Atrás',
		create: 'Crear',
		confirm: 'Confirmar',
		import: 'Importar',
	},

	error: 'Error',
	by: 'por',
	overwrite: 'sobrescribir',
	warningExpandedGroup: 'Grupo no tiene la opción" expandir y contraer grupo "establecida en Studio',
	groupWithoutField: 'El grupo no ha ingresado ningún campo',
	warningEventSubscribeGroup: 'Este evento no está implementado para el contenedor',
	from: 'de',

	erro: {
		button: {
			close: 'Cerrar mensaje de error'
		}
	},

	masks: {
		date: {
			alias: 'dd/mm/yyyy',
		},
		datetime: {
			mask: 'd/m/y hh:ss',
		},
		cep: "99999-999",
		cnpj: "99.999.999/9999-99",
		cpf: "999.999.999-99",
		telefone: "(99) 9999-9999",
		celular: "(99) [9]9999-9999",
		decimal: {
			alias: "decimal",
			groupSeparator: ".",
			radixPoint: ",",
			removeMaskOnSubmit: true,
			autoGroup: true,
			digitsOptional: false,
			integerDigits: 10,
			digits: 2,
			placeholder: "0",
			clearMaskOnLostFocus: false
		},
		currency: {
			alias: "currency",
			prefix: "R$ ",
			groupSeparator: ".",
			radixPoint: ",",
			placeholder: "0",
			removeMaskOnSubmit: true,
			integerDigits: 10,
			digits: 2
		}
	},

	datefilter: {
		from: 'De',
		to: 'Até',
	},

	date: {
		formats: {
			default: 'DD/MM/YYYY HH:mm',
			date: 'DD/MM/YYYY',
		},
	},

	actions: {
		clear: 'Limpiar',
		filter: 'Filtrar',
		add: 'Agregar datos a la tabla',
		back: 'Vuelve',
		cancel: 'Cancelar',
		update: 'Actualizar',
		close: 'Cerca'
	},

	grid: {
		mathFuncitons: {
			operatorErrorType: "La columna que desea calcular debe ser numérica, decimal o monetaria."
		}
	},

	datepicker: {
		monthsFull: ['Enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
		monthsShort: [ 'eno', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dic' ],
		weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
		weekdaysShort: [ 'dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sab' ],
		today: 'hoy',
		clear: 'claro',
		close: 'cerrar'
	},

	history: {
		title: 'Histórico',
		activity: 'Paso',
		responsible: 'Responsable de la etapa',
		date: 'Datar',
		by: 'por',
		in: 'em',
		show: "Mostrar historial",
		hide: "Ocultar historial"
	},

	activity: {
		messages: {
			integration: 'integración',
			executed: 'realizada'
		}
	},

	form: {
		validations: {
			required: 'Este campo es obligatorio.',
			fields_required: 'Hay campos obligatorios para completar'
		},
		errors: {
			error_default: 'Por favor verifique los errores a continuación.',
			required_file_type: 'El tipo de archivo es un campo obligatorio',
			unknown_error: 'Error inesperado.',
			null_pointer_exception: 'Error inesperado.',
			user_not_found: 'Usuario no encontrado Este problema probablemente fue causado por una pérdida de sesión, inicie sesión nuevamente e intente nuevamente.',
			activity_not_defined: 'El siguiente paso no se ha establecido.',
			action_to_assign_user_not_permited: 'No tiene permiso para redirigir esta actividad a otro usuario. Solo los gerentes de procesos pueden realizar esta acción.',
			user_route_not_informed: 'Usuario no informado para la ruta.',
			invalid_route: 'Enrutamiento no válido.',
			invalid_action_type: 'Enrutamiento no válido.',
			user_scaling_defined_not_exists: 'Escalada de usuario inválida',
			function_scaling_defined_not_exists: 'Escalada de función inválida',
			user_scaling_not_defined: 'Escalado para usuario no definido',
			group_scaling_defined_not_exists: 'Escalada de grupo no válida',
			user_inactive_for_scaling: 'Usuario inactivo para escalación',
			user_alternative_scaling_defined_not_exists: 'Escalada de usuario inválida',
			activity_executed: 'Paso ya realizado.',
			sql_not_executed: 'Error al ejecutar SQL. Marque los campos configurados para el tipo de inicialización como "Seleccionar resultado" o en la configuración "Seleccionar resultado por página".',
			invalid_environment_mode: 'Modo de acceso no válido, cambie a prueba o normal.',
			invalid_environment_mode: 'Modo de acceso no válido, cambie a prueba o normal.',
			invalid_environment_mode_subprocess: 'El modo de acceso (normal o prueba) debe ser el mismo entre el proceso y el subproceso.',
			user_defined_not_exists: 'Enrutamiento no válido ingresado.',
			group_not_exist: 'Grupo inválido.',
			access_denied: 'El usuario no tiene permiso de acceso.',
			access_denied_for_activity_instance: 'El usuario no tiene permiso de acceso.',
			is_public: 'El usuario seleccionado como público no es el mismo usuario responsable del paso.',
			script_invalid: 'La siguiente actividad no se pudo determinar porque el script configurado en esta actividad no es válido.',
			subprocess_referenced_not_configured: 'La llamada al subproceso no se ha configurado correctamente.',
			behavior: {
				event:{
					invalid_element: 'Error al interpretar el motor de reglas: ¡No se pudo agregar un evento al campo porque el campo no existe en la plantilla o está oculto en este paso!'
				},
				action:{
					invalid_element: 'Error al interpretar el motor de reglas: ¡No se pudo realizar una acción en un elemento dado porque el elemento no existe en el modelo o está oculto en este paso!'
				}
			},
			are_all_inputs_hidden: 'Todos los campos en este paso están ocultos o invisibles',
			process_definition_permition: 'Sin permiso para abrir el proceso',
			table_not_generated: 'La siguiente tabla de instancias no se generó',
			process_has_been_canceled: 'El proceso ya ha sido cancelado',
			Integration_in_lock: 'Una acción está en progreso, actualice la página en un momento para verificar el estado del paso',
			alternative_user_not_exist: 'Usuario sustituto no registrado',
			invalid_date: 'Fecha inválida',
			sub_process_non_actived: 'No se pudo iniciar el Subproceso, consulte con el Gerente de este proceso si está publicado (activo).',
			form_is_not_public: "La actividad no está configurada como formulario público.",
			unauthorized: "Acceso denegado.",
			ticket_not_valid: "Acceso denegado."
		},
		warnings: {
			max_length_numeric_api: 'El valor @ excede el máximo permitido de'
		},
		messages: {
			info_required: '(*) Campos obligatorios.',
			info_warning_external_manipulation: '(!) Los valores del campo numérico/monetario excedieron el tamaño máximo permitido.'
		},
		errorExecuteAction: 'Se produjo un error al realizar esta acción',
		errorPossibleExecuteAction: 'No se pudo realizar esta acción',
		warnNotPropAPILabel: 'El componente de la etiqueta de tipo no contiene esta propiedad en su estructura.',
		invalid_text_value_size: 'El tamaño del campo no está dentro del valor aceptado por el banco.'
	},

	inputs: {
		file: {
			buttonName: 'archivo'
		},
		autocomplete: {
			clear: 'Limpiar elementos seleccionados'
		}
	},

	template: {
		defaultLabel: 'Plantilla',
		titles: {
			create: 'Crear documento',
			import: 'Importar Documento',
			attach: 'Adjuntar documento',
			manage: 'Gestionar documento',
			detachOrDelete: 'Desvincular o eliminar documento',
			detach: 'Desvincular documento',
			delete: 'Eliminar documento',
			handleDuplicate: 'Tratar documento duplicado',
			handleDivergentVersions: 'Versiones divergentes',
			documentProperties: 'Propiedades del documento',
			documentFields: 'Campos del documento',
			fileData: 'Datos de archivo',
		},
		actions: {
			create: 'Crear',
			import: 'Importar',
			attach: 'Adjuntar',
			manage: 'Administrar',
			detach: 'Desvincular',
			delete: 'Eliminar',
			search: 'Buscar',
			onlyDetach: 'Solo desvincular',
			checkout: 'Revisa',
			cancelCheckout: 'Cancelar edición',
			checkin: 'Registrarse',
			overwrite: 'Sobrescribir',
			duplicate: 'Duplicar',
			downloadDocument: 'Descargar documento',
			showGraph: 'Mostrar gráfico',
			hideChart: 'Ocultar gráfico',
			selectVersion: 'Sí',
			notOverwrite: 'El documento seleccionado no se puede sobrescribir, ya que se ha agregado a través del proceso.',
			sortAscText: 'Ordenar de A - Z',
			sortDescText: 'Ordenar de Z - A',
			sortAscNumber: 'Ordenar de 1 - 9',
			sortDescNumber: 'Ordenar de 9 - 1',
			previewDocument: 'Ver documento',
			summary: 'Resumir documento'
		},
		messages: {
			processing: 'Procesamiento',
			gridDetachModal: 'Desvincular o eliminar acciones tendrá efecto inmediatamente en la celda del documento en la cuadrícula',
			detachOrDelete: '¿Desea desvincular, también eliminar este documento?',
			detach: 'Tem certeza que deseja desvincular este documento?',
			delete: '¿Seguro que quieres eliminar este documento?',
			documentReadonly: 'Archivo bloqueado para edición',
			documentLockedForCheckout: 'Este documento no se puede abrir para editarlo en este momento',
			handleDuplicate: 'Este documento ya existe, ¿quieres duplicarlo?',
			handleDivergentVersions: 'El archivo actual no se puede editar ya que hay una nueva versión. ¿Desea seleccionar la última versión del archivo para editar? ',
			handleCheckoutUndone: 'El registro no se puede realizar porque el archivo actual no tiene bloqueo para editarlo',
			file_type_restriction_exception: 'No se pudo realizar la acción porque el tipo de documento no está permitido.',
			profile_can_not_edit_document: 'No tiene permiso para realizar esta acción en la plantilla',
			licenseECM: 'Opción no disponible para el tipo de licencia ECM actual.',
			maxFileSizeAllowed: 'No se puede cargar el documento. Porque el tamaño del archivo ##size## Kb es mayor que el permitido.',
			previewDocumentNotEnabled: 'Vista previa del documento solo disponible en modo normal'
		},
		attributes: {
			file: 'Archivo',
			fileType: 'Tipo de archivo',
			fileName: 'Nombre de archivo',
			author: 'Autor',
			version: 'Versión',
			currentVersion: 'Versión actual',
			createdAt: 'Datar de creación'
		}
	},

	processInstance: {
		status: 'Status',
		code: 'Código'
	},

	modal: {
		loading: 'Espera Cargando ...',
		lupa: {
			warningSelectLupa: 'Error al ejecutar el filtro. Verifique la configuración de la proceso.'
		},
		editGridModal: 'Editar los datos',
		createGridModal: 'Ingresa los datos'
	},

	process: {
		description: 'Descripción del proceso.',
		helpText: 'Ayuda',
		helpModalTitle: 'Informaciones',
		assignToUserModelTitle: 'Redirigir',
		actions: {
			cancel: 'Cancelar',
			finish: 'Terminar'
		},
		messages: {
			processFinished: 'Proceso terminado'
		},
		status: {
			COMPLETED: 'APROBADO',
			REJECTED: 'RECHAZADO'
		},
		helpTitle: 'Ayuda de proceso',
		helpDesc: 'Descripción',
		helpDescEmpty: 'Sin descripción',
		helpTextModal: 'Texto de ayuda',
		helpTextEmpty: 'Sin texto de ayuda',
		helpFile: 'Archivo',
		helpFileDownload: 'Descargar archivo de ayuda',
		helpFileEmpty: 'No hay archivos'
	},

	activity: {
		cycle: 'Ciclo',
		due_date: 'Fecha límite de actividad',
		start_date: 'Inicio de actividad',
		finish_date: 'Finalización de actividad',
		actions: {
			approve: 'Aprobar',
			reject: 'Rechazar',
			openLookup: 'Lupa abierta'
		},
		toolbox: {
			toolboxName: "Acciones",
			saveActivity: 'Guardar',
			downloadProcessHelpFile: 'Archivo de ayuda',
			assignToUser: 'Redirigir a otro usuario',
			markActivityAsUnread: 'Marcar como no leído',
			openTimeLine: 'Abrir transmisión',
			cancelProcess: 'Cancelar proceso',
			printForm: 'Imprimir',
			openProcessHelpModal: "Informaciones",
			openAssignActivityToUserModal: "Asignar actividad"
		},
		assignToUserModal: {
			selectUser: 'Seleccione un usuario para redirigir',
			selectUserWarning: '¡Antes de confirmar la redirección, seleccione un usuario!'
		},
		messages: {
			nextActivity: 'Siguiente actividad',
			nextResponsibles: 'Next Responsible',
			activityFinished: 'Actividad registrado con éxito',
			activityCancelled: '¡Actividad cancelado con éxito!',
			multipleApprovalFailed: '¡No se pudo realizar la aprobación automática porque el paso no permite la aprobación!',
			multipleRejectionFailed: '¡No se puede rechazar automáticamente porque el paso no permite el rechazo!',
			integración: 'Integración',
			ejecutado: 'ejecutado',
			concentratorActivity: 'Concentrator step',
			concentratorActivityWithPendingActivities: 'Este es un paso de concentrador, y se lanzará cuando se completen todos los pasos paralelos',
			activityBlocked: 'Paso bloqueado',
			finalActivity: 'Finalization actividad',
			subProcess: 'Se ha abierto una nueva instancia de proceso: Código'
		},
		status: {
			CANCELLED: 'Cancelado',
			IN_PROGRESS: 'En proceso',
			APPROVED: 'Aprobado',
			REJECTED: 'Rechazado',
			EXCLUDED: 'Excluido',
			HIBERNATED: 'Hibernar',
			HIBERNATING: 'En hibernación',
			LATE: 'Tarde',
			FINALIZED: 'Terminado',
			OPENING: 'En la apertura',
			SCHEDULED: 'Escalonado',
		}
	},

	successResponseMessages: {
		saveActivity: 'Los datos de la actividad se guardaron con éxito',
		cancelProcess: 'El proceso se canceló con éxito',
		markActivityAsUnread: 'La actividad ha sido marcada como "no leída" con éxito.',
		executeActivityToUser: 'Actividad redirigida con éxito. Usuario responsable de la próxima actividad: ',
		executeActivityToUserTitle: '¡Paso redirigido con éxito!'
	},

	confirmMessages: {
		cancelProcess: '¿Estás seguro de que deseas cancelar este proceso? Esta acción es irreversible.'
	},

	javascript: {
		errors: {
			noLoad: "Error al cargar el script personalizado definido en este paso."
		}
	},

	table: {
		cell: {
			formats: {
				number: '0,0.[000]',
				percentage: '0.00%',
				currency: 'R$ 0,0.00',
				date: 'DD/MM/YYYY',
				datetime: 'DD/MM/YYYY HH:mm',
				time: 'HH:mm',
			}
		},
		columnActions: 'Acciones',
		emptyResult: 'Sin datos agregados',
		emptyResultSearcher: 'No se encontraron datos'
	},

	general: {
		date: {
			format_date: 'Completar formato',
			format: 'día, mes y año',
			invalid: 'no valido',

		},
		button: {
			edit: 'Editar',
			delete: 'Eliminar',
			download: 'Descargar',
			help_modal: 'Botón de ayuda modal'
		},
		description:{
			refresh: 'Actualizar: presione la tecla Intro para cargar un valor automático.',
			date: 'Fecha: presione la tecla Intro para abrir el modo de selección de fecha.',
			magnifying_glass: 'Lupa: presione la tecla Intro para acceder al modal y realizar una búsqueda.'
		},
		textarea: {
			maxlength: 'La cantidad de caracteres ingresados es @ como máximo #.'
		},
		error: {
			close: 'Cerrar mensaje de error.'
		},
		success: {
			close: 'Cerrar mensaje.'
		},
		nuevo_documento: 'Crear un nuevo documento',
		not_attached_document: 'Importar un nuevo documento.',
		attach_document: 'Adjuntar un nuevo documento',
		document_create: 'Se creó el documento @',
		attach_document_form: 'El documento @ se ha adjuntado al formulario',
		group_label: 'Ocultar o mostrar contenido del formulario: el estado actual es @',
		close: 'cerrado',
		open: 'abrir',
		select: 'Seleccione',
		open_options: 'Ofrecer espacio para abrir @ opciones',
		options_selected: 'Opción seleccionada @',
		not_options_selected: 'No hay una opción seleccionada',
		search: {
			options: '@ Opción enfocada, # de y resultados disponibles. Use Tab para ir a la siguiente opción o Tab + Mayús para volver a la opción anterior, presione Entrar para seleccionar la opción enfocada actualmente, presione Esc para salir del menú.'
		},
		empty_result_list: 'No se encontraron elementos',
		show_help_text: 'Presione Enter para abrir la ayuda modal.',
		filter_to: 'Buscar @ o ir a la lista usando la pestaña o hacia abajo'
	},

	exportMultipleModal: {
		export: 'Descargar',
        exporting: 'Descargando',
        modalTitle: 'Descarga múltiples archivos',
        success_message: '¡Archivo(s) descargado(s) con éxito!',
		was_selected: 'Se han seleccionado',
		total_files: 'archivos totales.',
		of: 'de',
		associated_fields: 'Campos asociados',
		file_name: 'Nombre del archivo',
		field_without_name: '- Campo sin nombre',
		search_by_field_name: 'Ingrese el nombre del archivo o del campo para filtrar',
		error: {
          	unexpected_error: 'No se han podido descargar los archivos. Vuelva a intentarlo más tarde.',
          	ecm_connection_error: 'No hemos podido descargar los archivos porque se ha producido un error de comunicación entre los módulos. Vuelva a intentarlo más tarde.',
          	size_exceeded_error: 'No ha sido posible descargar los archivos porque el tamaño total de #size_of_exportation supera el límite permitido de #limit_of_exportation. Seleccione menos archivos e inténtelo de nuevo.',
          	export_files_error: 'No se han podido descargar los archivos. Compruebe los errores de cada archivo e inténtelo de nuevo.',
			files_not_found: 'No se encontraron archivos para descargar.',
			document_not_found: 'Archivo no encontrado.',
			document_not_found_exception: 'Archivo no encontrado.',
			document_not_found_in_storage_exception: 'Archivo no encontrado.',
			access_to_file_denied_exception: 'No tiene permiso para exportar este archivo.',
			document_not_in_the_process_instance_excepion: 'Archivo no vinculado a la actividad.',
			document_associated_with_a_hidden_field_exception: 'El archivo no está disponible.',
		},
		actions: {
			load: 'Cargar'
		}
	},
	importMultipleModal: {
		modalTitle: 'Carga varios archivos',
		modalTitleGrid: 'Carga varios archivos na grid',
		selectDocumentFieldsDefault: 'Elija un campo para vincular al archivo',
		filesListErrors: {
			emptyDocuments: 'El archivo no está vinculado a un campo.',
			alreadyFileLinked: 'El campo ya contiene un archivo importado',
			emptyFieldsMetadata: 'metadatos',
			emptyFieldsGrid: 'campos de cuadrícula',
			emptyFieldsAnd: 'es',
			emptyFieldsBegin: 'Existen',
			emptyFieldsEnd: 'para ser llenado',
			duplicatedDocuments: 'Hay datos duplicados, haga clic en el icono para resolver',
			divergentVersionInCheckin: 'Hay divergencia entre versiones en checkin',
			checkoutUndone: 'Este documento ya está bloqueado para registrarse',
			document_not_associeted_process_instance_exception: "Documento no asociado con instancia de proceso",
			document_not_found: "Documento no encontrado",
			document_locked: "Documento bloqueado",
			profile_can_not_edit_document: "Tu perfil no puede editar el documento",
			wrong_version: "Versión incorrecta",
			profile_has_no_access_on_template: "El perfil no tiene acceso a la plantilla",
			file_required: "El archivo es requerido",
			version_collision: "Esta versión ya existe",
			document_major_version: "Existe una versión principal para este documento",
			checkout_not_performed: "Este documento no tiene bloqueo de edición",
			document_locked_for_override: "Documento bloqueado para anular",
			invalid_file_name: "El archivo contiene un carácter inválido en el nombre (: ? * \" < > | \\)",
			missing_params_exception: "Parámetros faltantes",
			ecm_file_not_found: "Archivo ECM no encontrado",
			file_type_restriction_exception: "La plantilla no permite el tipo '@'",
			file_size_restriction_exception: "El archivo ha excedido el tamaño máximo permitido de @ Kb configurado en la plantilla",
			document_cannot_be_deleted_exception: "El documento no se puede eliminar",
			file_session_already_closed_exception: "Sesión de archivo ya cerrada",
			file_session_not_found_exception: "Sesión de archivo no encontrada",
			file_not_found_in_storage_exception: "Archivo no encontrado",
		},
		dropZone: 'Arrastre y suelte sus archivos aquí o haga clic para seleccionarlos',
		successImport: 'Archivo importado con éxito',
		removeFile: 'Eliminar archivo de la lista',
		metadataFields: 'Metadatos de relleno',
		importing: 'Cargando...',
		fillLineFields: 'Campos de línea de relleno'
	}

}, 'es');
